import { motion } from "framer-motion";
import { BrainCircuit, Network, Compass, Clapperboard } from "lucide-react";

const VALUES = [
  {
    id: "depth",
    icon: BrainCircuit,
    title: "Zero Clickbait, Full Depth",
    desc: "Unedited long-form conversations that respect nuance. Your story won't be cut into a 15-second outrage clip.",
  },
  {
    id: "network",
    icon: Network,
    title: "High-Net-Worth Amplification",
    desc: "Your episode travels directly into a 45,000+ verified investor and founder circle — the audience leaders actually want.",
  },
  {
    id: "iq-framework",
    icon: Compass,
    title: "The Income Quotient Lens",
    desc: "A fresh framework on monetary architecture — far beyond the standard PR talking points you've answered a hundred times.",
  },
  {
    id: "production",
    icon: Clapperboard,
    title: "Cinematic Production",
    desc: "4K multi-cam, sound mastered for audiophiles, and social cutdowns handed to your PR team after every episode.",
  },
];

const ValuePitch = () => {
  return (
    <section id="the-pitch" className="relative py-16 sm:py-24 px-4">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <p className="text-xs font-semibold tracking-[0.22em] uppercase text-amber-400">The Pitch</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">
            Why high-calibre leaders
            <br className="hidden sm:block" />
            <span className="text-slate-400">say yes to this chair.</span>
          </h2>
        </motion.div>

        <div className="mt-10 sm:mt-14 grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {VALUES.map((v, i) => (
            <motion.div
              key={v.id}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`pitch-card-${v.id}`}
              className={`glass-panel rounded-[1.75rem] p-6 sm:p-10 neu-lift ${i % 2 === 1 ? "md:translate-y-6" : ""}`}
            >
              <span className="clay-badge w-12 h-12 sm:w-14 sm:h-14 rounded-2xl flex items-center justify-center">
                <v.icon className="w-6 h-6 text-amber-400" />
              </span>
              <h3 className="mt-5 sm:mt-6 font-display text-xl font-semibold">{v.title}</h3>
              <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed">{v.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePitch;
